export default __webpack_public_path__ + "static/media/sb-ICO-03.22beb82c.webp";